<app-top-navbar />

<!-- Hero Section -->
<app-hero-section />

<!--  Accessibility Widget  -->
<app-accessibility-widget />

<!-- Divider -->
<div class="h-[1px] bg-primary-200"></div>

<!-- Enrolled Institutions -->
<app-enrolled-institutions />

<!-- Bottom Divider -->
<div class="h-[1px] bg-primary-200"></div>

<!-- About Us Section -->
<app-about-us />

<!-- System Features -->
<app-system-features />

<!-- MEL Framework (Monitoring · Evaluation · Learning) + CTA -->
<app-mel-framework />

<!-- Our Projects Section -->
<app-flagship-projects />

<!-- Frequently Asked Questions Section -->
<app-faqs-component />

<!-- Divider -->
<div class="max-w-screen-xl mx-auto h-[1px] bg-primary-200 mb-3"></div>

<app-footer-component />
